var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-visual"
  }, [_c('video', {
    staticClass: "main-visual__video",
    attrs: {
      "src": "/images/main/visual.mp4",
      "poster": "/images/main/visual-thumb.jpg",
      "loop": "",
      "autoplay": "",
      "muted": "",
      "playsinline": ""
    },
    domProps: {
      "muted": true
    }
  }), _c('div', {
    staticClass: "main-visual__inner"
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }